import AutoplayModel from "slotworks/model/autoplay-model";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class IsAutoplay extends Decision {
    public evaluate() {
        return AutoplayModel.isAutoPlaying() ? Exit.True : Exit.False;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/decisions/is-autoplay.ts